import { ENV } from '@/configurations/env';
import { createUploadLink } from 'apollo-upload-client';
export var uploadLink = createUploadLink({
    uri: ENV.BFF_URL,
    credentials: 'include',
});
